(function ($) {
    if ($('#find-installer-home, #find-installer-widget, #find-installer-map, #find-installer-footer').length > 0) {
        $('#find-installer-home, #find-installer-widget, #find-installer-map, #find-installer-footer').on('submit', function (e) {
            e.preventDefault();

            const postal_code = $(this).find('input[name="postal_code"]').val() || false;
            const country_code = $(this).find('.countrySelection').val() || false;

            if (!country_code) {
                alert(findInstallerData.pleaseSelectCountryMessage || 'Please select a country.');
                return;
            } else if (!postal_code) {
                alert(findInstallerData.pleaseEnterPostalCodeMessage || 'Please enter a postal code.');
                return;
            }

            // Requirement passed, proceed with ajax request.
            const currentForm = $(this);
            currentForm.addClass('loading');

            const submitButton = currentForm.find('button[type="submit"]');
            submitButton.prop('disabled', true).text(findInstallerData.searchingMessage || 'Searching…');

            $.ajax({
                url: findInstallerData.ajaxUrl,
                method: 'POST',
                data: {
                    action: 'lookup',
                    postal_code: postal_code,
                    country_code: country_code
                },
                success: function (response) {
                    // if we find something, lets populate the banner with the installer info and show it, else show an alert.
                    if (response.success) {

                        const installer = response.data;

                        // Maybe redirect
                        if ( 'find-installer-map' === currentForm.attr('id') ) {
                            window.location.href = installer.permalink;
                            return;
                        }
                        if  ( 'find-installer-footer' === currentForm.attr('id') ) {
                            window.location.href = installer.permalink;
                            return;
                        }

                        $('.installer-image').css('background-image', `url(${installer.miniature})`).css('display', false);
                        $('.installer-name').text(installer.name);
                        $('.installer-region').text(installer.region);
                        $('.installer-phone').attr('href', `tel:${installer.phone_tel}`).text(installer.phone);

                        $('.button-goto-installer').attr('href', installer.permalink);

                        $('.installer-search').addClass('hide');
                        $('.installer-found').removeClass('hide');

                        currentForm.find('input[name="postal_code"]').val('');
                    } else {
                        alert(findInstallerData.noInstallerFoundMessage || 'No installer found for the provided location. Please try again with a different postal code or country.');
                    }
                },
                error: function () {
                    alert('An error occurred while looking up the installer. Please try again.');
                },
                complete: function () {
                    submitButton.prop('disabled', false).text(findInstallerData.searchButtonLabel || 'Search');
                    currentForm.removeClass('loading');
                }

            });

        });

        $('.countrySelection').on('change', function () {
            const selectedCountryCode = this.value;
            const postalCodeLabel = country_data[selectedCountryCode] ? country_data[selectedCountryCode].postal_code_label : 'Postal Code';

            // Update the labels based on the selected country
            $('.postal-code-label').text(postalCodeLabel);

            // update all other selects
            $('.countrySelection').val(selectedCountryCode).trigger('change');
        });

        // update all postal code inputs on change
        $('input[name="postal_code"]').on('change', function (e) {
            const newPostalCode = this.value;
            $('input[name="postal_code"]').not(this).val(newPostalCode).trigger('change');
        });

        /* Reset region */
        /**
         * Destroy cookies and reset the installer search to show the form again
         */
        $('.change-region').on('click', function (e) {
            e.preventDefault();

            // clear cookie nearestInstallerId
            document.cookie = 'nearestInstallerId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

            // show installer search form again
            $('.installer-search').removeClass('hide');
            $('.installer-found').addClass('hide');

        });
    }



})(jQuery);   